import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "level" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "subtitle" }, "View registration details", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("hr", { class: "is-third is-centered" }, null, -1)
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "block is-expanded" }
const _hoisted_8 = { class: "has-text-primary" }
const _hoisted_9 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Rejection Comments:", -1)
const _hoisted_11 = { class: "is-expanded has-text-danger" }
const _hoisted_12 = {
  key: 1,
  class: "columns is-multiline"
}
const _hoisted_13 = { class: "is-full" }
const _hoisted_14 = { class: "field" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Comments", -1)
const _hoisted_16 = { class: "is-expanded" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "block is-expanded" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Quotes", -1)
const _hoisted_20 = { class: "mb-5 block is-expanded" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Debit Authorizations", -1)
const _hoisted_22 = { class: "columns is-multiline" }
const _hoisted_23 = { class: "is-two-fifths" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Supporting Documents", -1)
const _hoisted_25 = { class: "is-flex is-flex-wrap-wrap" }
const _hoisted_26 = {
  key: 0,
  class: "is-three-fifths"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "label" }, "History", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailActions = _resolveComponent("DetailActions")
  const _component_RegistrationReviewManager = _resolveComponent("RegistrationReviewManager")
  const _component_DetailFields = _resolveComponent("DetailFields")
  const _component_DetailInternalComments = _resolveComponent("DetailInternalComments")
  const _component_DetailExternalComments = _resolveComponent("DetailExternalComments")
  const _component_DetailGridQuotes = _resolveComponent("DetailGridQuotes")
  const _component_DetailGridDebitAuths = _resolveComponent("DetailGridDebitAuths")
  const _component_DetailSupportingDocs = _resolveComponent("DetailSupportingDocs")
  const _component_DetailGridHistory = _resolveComponent("DetailGridHistory")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", null, [
        _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.pageTitle), 1),
        _hoisted_4
      ]),
      (_ctx.registration)
        ? (_openBlock(), _createBlock(_component_DetailActions, {
            key: 0,
            registrationDetail: _ctx.registration,
            "onUpdate:registrationDetail": _cache[1] || (_cache[1] = ($event: any) => (_ctx.registration = $event)),
            onActionDone: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadDetail()))
          }, null, 8, ["registrationDetail"]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_5,
    (_ctx.registration)
      ? (_openBlock(), _createBlock(_component_RegistrationReviewManager, {
          key: 0,
          registration: _ctx.registration,
          onReviewSaved: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadDetail()))
        }, null, 8, ["registration"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("h3", _hoisted_8, _toDisplayString(_ctx.registration?.registrationNumber || "") + " - " + _toDisplayString(_ctx.registration?.registrationStatusName || ""), 1)
      ]),
      (_ctx.registration?.rejectionComments)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("div", _hoisted_11, [
              _createVNode("span", null, _toDisplayString(_ctx.registration?.rejectionComments), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_DetailFields, { registrationDetail: _ctx.registration }, null, 8, ["registrationDetail"]),
      (_ctx.registration?.reviewRequestComments)
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.registration?.reviewRequestComments), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.userAuth.isAllegro)
      ? (_openBlock(), _createBlock(_component_DetailInternalComments, {
          key: 1,
          class: "mb-5",
          registration: _ctx.registration
        }, null, 8, ["registration"]))
      : _createCommentVNode("", true),
    _createVNode(_component_DetailExternalComments, {
      class: "mb-5",
      registration: _ctx.registration
    }, null, 8, ["registration"]),
    (_ctx.areQuotesAndDebitAuthsVisible)
      ? (_openBlock(), _createBlock("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_DetailGridQuotes, {
              key: _ctx.registration?.registrationNumber,
              registrationNumber: _ctx.registration?.registrationNumber
            }, null, 8, ["registrationNumber"])
          ]),
          _createVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_DetailGridDebitAuths, {
              key: _ctx.registration?.registrationNumber,
              registrationNumber: _ctx.registration?.registrationNumber
            }, null, 8, ["registrationNumber"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_22, [
      _createVNode("div", _hoisted_23, [
        _hoisted_24,
        _createVNode("div", _hoisted_25, [
          _createVNode(_component_DetailSupportingDocs, {
            documents: _ctx.registration?.documents,
            areFilesArchived: _ctx.isArchived
          }, null, 8, ["documents", "areFilesArchived"])
        ])
      ]),
      (_ctx.userAuth.canViewRegistrationHistory)
        ? (_openBlock(), _createBlock("div", _hoisted_26, [
            _hoisted_27,
            _createVNode(_component_DetailGridHistory, { registration: _ctx.registration }, null, 8, ["registration"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}